import { Fragment } from "react";
import { IconButton, styled } from "@mui/material";

import { topBarHeight } from "app/utils/constant";
import { themeShadows } from "app/components/MatxTheme/themeColors";

// STYLED COMPONENTS
const SearchContainer = styled("div")(({ theme }) => ({
  //position: "absolute",
  //top: 0,
  //left: 0,
  //zIndex: 9,
  width: "100%",
  display: "flex",
  alignItems: "center",
  height: topBarHeight,
  background: theme.palette.primary.info,
  color: theme.palette.text.primary,
  "&::placeholder": {
    color: theme.palette.text.primary
  },
  marginBottom: "26px",
  borderRadius: "4px",
  boxShadow: themeShadows[12]
}));

const SearchInput = styled("input")(({ theme }) => ({
  width: "100%",
  border: "none",
  outline: "none",
  fontSize: "1rem",
  paddingLeft: "20px",
  height: "calc(100% - 5px)",
  background: theme.palette.primary.info,
  color: theme.palette.text.primary,
  "&::placeholder": { color: theme.palette.text.primary }
}));

export default function MatxSearchBox({ searchTerm, onChange, onKeyDown }) {
  return (
    <Fragment>
      <SearchContainer>
        <SearchInput
          type="text"
          placeholder={`Pesquisar...`}
          autoFocus
          onChange={(event) => {
            console.log(event.target.value);
          }}
        />
        <IconButton onClick={() => {}} sx={{ mx: 2, verticalAlign: "middle" }}></IconButton>
      </SearchContainer>
    </Fragment>
  );
}
